import React from "react";

import loadable from "@loadable/component";

// import SubMenuListParent from '../../components/SubMenu';
// import BlogDetail from './BlogDetail';
// import BookBtn from "../../components/BookBtn";

const SubMenuListParent = loadable(() => import('../../components/SubMenu'));
const BlogDetail = loadable(() => import('./BlogDetail'));
const BookBtn = loadable(() => import('../../components/BookBtn'));

function Blogs() {
  const Names = [
    {text: 'Blogs', link: '../blogs', active: true},
    // {text: 'News', link: '../news'}, 
    // {text: 'Events', link: '../events'}, 
    // {text: 'Press Releases', link: '../press-releases'}, 
    // {text: 'Newsletters', link: '../newsletters'},
  ];
  return (
    <div className="Blogs PaddingTopHeding SingleURL">
      <SubMenuListParent SubMenuNames={Names} />
      <BlogDetail />
      <BookBtn/>
    </div>
  );
}

export default Blogs;